import { loadFromAPIs } from '@utilities/fetch';

export type PkContentLoaderPluginOptions = {
  libraryBasePath: string;
};

const defaults: PkContentLoaderPluginOptions = {
  libraryBasePath: '',
};

type PkChangeEvent = CustomEvent<{ expanded: boolean }>;
type PkTabChangeEvent = CustomEvent<{ tabId: string; tabElem: HTMLPkTabElement }>;

export default class PkContentLoaderPlugin {
  dom: HTMLPkAccordionItemElement | HTMLPkCollapseElement | HTMLPkDialogElement | HTMLPkTabsElement | HTMLElement;
  opt: PkContentLoaderPluginOptions;
  lastTargetPath: string;

  constructor(e: HTMLElement, o: PkContentLoaderPluginOptions) {
    this.dom = e;
    this.opt = { ...defaults, ...o };
  }

  init() {
    switch (this.dom.tagName) {
      case 'PK-ACCORDION-ITEM':
        this.dom.addEventListener('pkToggle', this.onOpen);
        break;
      case 'PK-COLLAPSE':
        this.dom.addEventListener('pkChange', this.onOpen);
        break;
      case 'PK-DIALOG':
        this.dom.addEventListener('pkOpen', this.onOpen);
        break;
      case 'PK-TABS':
        {
          this.dom.addEventListener('pkChange', this.onTabChange);
          const selectedTab = this.dom.querySelector<HTMLPkTabElement>('pk-tab[selected]');
          selectedTab && this.onTabChange({ detail: { tabElem: selectedTab } } as PkTabChangeEvent);
        }
        break;
    }
  }

  onOpen = (event: PkChangeEvent) => {
    if (!event.detail.expanded) return;
    const target = this.dom.querySelector<HTMLElement>('.js-pk-loader-target');
    this.loadContent(this.dom.dataset.loadTarget, target);
  };

  onTabChange = (event: PkTabChangeEvent) => {
    const el = event.detail.tabElem;
    const targetPath = el.dataset.loadTarget;
    const targets = this.dom.querySelectorAll<HTMLPkTabPanelElement>('.js-pk-loader-target');
    targets.forEach((tg) => {
      if (tg.tab === el.tabId) {
        this.loadContent(targetPath, tg);
      } else {
        tg.innerHTML = '';
      }
    });
  };

  loadContent = async (targetPath: string, target: HTMLElement) => {
    const path = [this.opt.libraryBasePath, targetPath].filter(Boolean).join('/');
    if (this.lastTargetPath === path) return;

    target.innerHTML = '<pk-spinner size="70"></pk-spinner>';
    this.lastTargetPath = path;

    const content = await loadFromAPIs<string>(path, {}, { responseType: 'text' });
    target.innerHTML = content;
  };
}
